module.exports = __webpack_public_path__ + "images/10-i8b1feca66712225a2233d38ddbb6ed93.svg";